import API_BASE_URL from '../Config';

const USUARIO_API = `${API_BASE_URL}/usuarios`;

/**
 * Obtiene una lista paginada de usuarios con búsqueda.
 */
export const getUsuariosPaginados = async (page = 0, size = 10, search = '') => {
    const response = await fetch(`${USUARIO_API}?page=${page}&size=${size}&search=${search}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener usuarios`);
    return await response.json();
};

/**
 * Obtiene un usuario por su ID.
 */
export const getUsuarioById = async (id) => {
    const response = await fetch(`${USUARIO_API}/${id}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener el usuario`);
    return await response.json();
};

/**
 * Crea un nuevo usuario.
 */
export const createUsuario = async (usuarioData) => {
    const response = await fetch(USUARIO_API, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(usuarioData)
    });
    
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const error = new Error(errorData.message || 'Error al crear el usuario');
        error.status = response.status;
        error.errors = errorData.errors; // Mapa de errores detallados
        throw error;
    }
    return await response.json();
};

/**
 * Actualiza un usuario existente.
 */
export const updateUsuario = async (id, usuarioData) => {
    const response = await fetch(`${USUARIO_API}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(usuarioData)
    });
    
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const error = new Error(errorData.message || 'Error al actualizar el usuario');
        error.status = response.status;
        error.errors = errorData.errors;
        throw error;
    }
    return await response.json();
};

/**
 * Elimina un usuario.
 */
export const deleteUsuario = async (id) => {
    const response = await fetch(`${USUARIO_API}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al eliminar el usuario`);
    return true;
};
